import { unstable_usePrompt } from '@faceup/router'

type PromptProps = {
  message: string

  when: boolean
}

// react-router 7's useBlocker keeps only the last-registered blocker per
// router (it even warns "A router only supports one blocker at a time").
// If we always call unstable_usePrompt, an idle Prompt (when=false) can
// silently mask an active Prompt (when=true) just by mounting later.
// Skip the hook entirely when there's nothing to block so the active
// Prompt is the only blocker the router sees.
export const Prompt = ({ message, when }: PromptProps) => {
  if (!when) {
    return null
  }
  return <ActivePrompt message={message} />
}

const ActivePrompt = ({ message }: { message: string }) => {
  unstable_usePrompt({ when: true, message })
  return null
}
